<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('general_journal')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <router-link to="/accounting/journal" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('add_new')}}</router-link>
            <router-link to="/accounting/import/journal" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-file-excel-o"></i> {{$t('import')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('from_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="query.FromDate" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('to_date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="query.ToDate" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor" :class="{'table-striped': viewType==0}">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('date')}}</th>
                                <th>{{$t('type')}}</th>
                                <th>{{$t('ref_no')}}</th>
                                <th>{{$t('partner')}}</th>
                                <th>{{$t('account_name')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-right">{{$t('debit')}}</th>
                                <th class="text-right">{{$t('credit')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="viewType==0">
                                <tr v-for="(ret,index) in records" :key="index">
                                    <td>
                                        <router-link :to="{name: 'update_journal', params: {id: ret.Id}}">{{ret.TranNo.toString().padStart(5, '0')}}</router-link>
                                    </td>
                                    <td>{{$format(ret.Date,'DD-MM-YYYY')}}</td>
                                    <td>{{ret.TypeNo}}</td>
                                    <td>{{ret.RefNum}}</td>
                                    <td>{{ret.PartnerName}}</td>
                                    <td>{{ret.AccountName}}</td>
                                    <td>{{ret.Description}}</td>
                                    <td class="text-right">{{$money(ret.Debit)}}</td>
                                    <td class="text-right">{{$money(ret.Credit)}}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <template v-for="(ret,index) in journalGroups">
                                    <tr v-for="(line,lindex) in ret.JournalDataLists" :key="index+'-'+lindex">
                                        <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="text-align: center; vertical-align: middle;">
                                            <template v-if="line.TypeNo=='Manual'">
                                                <router-link :to="{name: 'update_journal', params: {id: line.Id}}">{{ret.TranNo.toString().padStart(5, '0')}}</router-link>
                                            </template>
                                            <template v-else>{{ret.TranNo.toString().padStart(5, '0')}}</template>  
                                        </td>
                                        <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="vertical-align: middle;">{{$format(line.Date,'DD-MM-YYYY')}}</td>
                                        <td v-if="lindex==0" :rowspan="ret.JournalDataLists.length" style="vertical-align: middle;">{{line.TypeNo}}</td>
                                        <td>{{line.RefNum}}</td>
                                        <td>{{line.PartnerName}}</td>
                                        <td>{{line.AccountName}}</td>
                                        <td>{{line.Description}}</td>
                                        <td class="text-right">{{$dollar2(line.Debit)}}</td>
                                        <td class="text-right">{{$dollar2(line.Credit)}}</td>
                                    </tr>
                                    <tr class="table-secondary" :key="index*10000">
                                        <th colspan="7" class="text-right"></th>
                                        <th class="text-right">{{$dollar(ret.TotalDebit)}}</th>
                                        <th class="text-right">{{$dollar(ret.TotalCredit)}}</th>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                        <tfoot>
                            <tr class="table-primary">
                                <th colspan="7" class="text-right">{{$t('balance')}}</th>
                                <th class="text-right">{{$dollar(footer.TotalDebit)}}</th>
                                <th class="text-right">{{$dollar(footer.TotalCredit)}}</th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            query: {
                FromDate: this.$startOfMonth(),
                ToDate: this.$endOfMonth(),
                IsGroup: true
            },
            records: [],
            journalGroups: [],
            viewType: 1,
            footer: {
                TotalDebit: 0,
                TotalCredit: 0
            }
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            let loading = this.$loading.show();
            this.$api().post('accounting/generaljournals', this.query).then(res => {
                if(this.$isValid(res)){
                    if(this.viewType == 0){
                        this.records = res.data.Json.Journals;
                    }else{
                        this.journalGroups = res.data.Json.JournalGroups;
                    }
                    this.calculate();
                }
            }).finally(() => { loading.hide(); });
        },
        viewTypeChange(n){
            this.viewType = n;
            this.query.IsGroup = this.viewType == 0?false:true;
            this.toList();
        },
        calculate(){
            let debits = 0;
            let credits = 0;
            if(this.viewType == 0){
                this.records.forEach(item => {
                    debits += Number(item.Debit);
                    credits += Number(item.Credit);
                });
            }else{
                this.journalGroups.forEach(item => {
                    debits += Number(item.TotalDebit);
                    credits += Number(item.TotalCredit);
                });
            }
            this.footer.TotalDebit = debits;
            this.footer.TotalCredit = credits;
        }
    }
}
</script>